import { User }             from '../models/User';
import { Game }             from '../models/Game';

enum MembershipStatus {
    ACTIVE = 'ACTIVE',
    CANCEL = 'CANCEL',
    DECEASED_SUSPEND = 'DECEASED_SUSPEND',
    EXPIRE = 'EXPIRE',
    MEMBER_REQUEST_SUSPEND = 'MEMBER_REQUEST_SUSPEND',
    UNDELIVERABLE_SUSPEND = 'UNDELIVERABLE_SUSPEND',
}

export class UserService {
    static isValidMember(user: User) {
        return user
            && user.aarpMembershipStatus === MembershipStatus.ACTIVE
            && new Date() < new Date(user.aarpMembershipExpirationDate);
    }

    static isUserAuthorized (user: User): boolean {
        return user ? !!user.id : false;
    }

    static gameForMemberIsUnavailable(user: User, game: Game, isPreviewMode: boolean = false): boolean {
        return !isPreviewMode && (game.membersOnly && !UserService.isValidMember(user));
    }
}
